import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=b1d34a4a&scoped=true&"
import script from "./InputColor.vue?vue&type=script&lang=js&"
export * from "./InputColor.vue?vue&type=script&lang=js&"
import style0 from "./InputColor.vue?vue&type=style&index=0&id=b1d34a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d34a4a",
  null
  
)

export default component.exports